<div class="col-xs-12" ng-show="usuarios">
  <div class="panel panel-default">
    <div class="panel-heading">Resultados</div>
    <div class="panel-body">
      <small ng-show="usuarios.length == 0">Nenhum resultado encontrado!</small>
      <table class="table table-hover table-striped" ng-show="usuarios.length > 0">
        <thead>
          <tr>
            <th class="col-xs-3">Login</th>
            <th class="col-xs-4">Nome</th>
            <th class="col-xs-3">CPF</th>
            <th class="col-xs-4">Função</th>
            <th class="col-xs-1">Mobile</th>
            <th class="col-xs-1">Telefone</th>
            <th class="col-xs-1"></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="usuario in usuarios track by $index">
            <td class="vertical-middle" style="border-left: 5px solid #{{usuario.cor}};">{{usuario.nome}}</td>
            <td class="vertical-middle">{{usuario.nome_completo}}</td>
            <td class="vertical-middle">{{usuario.cpf | formatCPF }}</td>
            <td class="vertical-middle">{{usuario.funcao_descricao | humanize}}</td>
            <td class="vertical-middle">{{usuario.utiliza_mobile ? 'Sim' : 'Não'}}</td>
            <td class="vertical-middle nowrap">{{usuario.telefone}}</td>
            <td class="vertical-middle text-right" ng-if="permissions.usuario.canManage">
              <div class="btn btn-danger btn-sm" ng-if="usuario.nome !== 'inovacao' || currentUser.nome === 'inovacao'" ng-click="disable(usuario)" uib-tooltip="Desativar" tooltip-placement="top">
                <i class="glyphicon glyphicon-remove-circle"></i>
              </div>
            </td>
            <td class="vertical-middle text-right">
              <div class="btn btn-primary btn-sm" ng-if="usuario.nome !== 'inovacao' || currentUser.nome === 'inovacao'" ng-click="configNotifications(usuario)" uib-tooltip="Alertas" tooltip-placement="top">
                <i class="fa fa-bell-o" aria-hidden="true"></i>
              </div>
            </td>
            <td class="vertical-middle text-right">
              <div class="btn btn-primary btn-sm" ng-if="usuario.nome !== 'inovacao' || currentUser.nome === 'inovacao'" ng-click="show($index)" uib-tooltip="Visualizar" tooltip-placement="top">
                <i class="glyphicon glyphicon-eye-open"></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-right">
        <ng-include src="'views/_pagination.html'"></ng-include>
      </div>
    </div>
  </div>
</div>
